<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <br><br>
            <div class="row">
                <div class="col-lg-6">
                    <h4>{{datosGrupo.nombre}} <button class="btn btn-secondary" (click)="cerrarGrupo(datosGrupo.id)">Cerrar</button></h4>
                    <p>
                        {{datosGrupo.carrera}}<br>
                        {{datosGrupo.escuela}}<br>
                    </p>
                </div>
                <div class="col-lg-6">
                    <strong>Paquetes Entregados: {{indicadores.entregados}}</strong><br>
                    <strong>Paquetes por Entregar: {{indicadores.por_entregar}}</strong><br>
                </div>
            </div>
           
            <table class="table table-striped">
                <thead>
                    <tr>
                        <td>ID</td>
                        <td>Nombre Completo</td>
                        <td>Paquetes</td>
                        <td>Monto Comprado</td>
                        <td>Descuentos</td>
                        <td>Total con descuento</td>
                        <td>Monto Pagado</td>
                        <td>Por Pagar</td>
                        <td>Pagos</td>
                        <td>Observaciones</td>
                        <td>Quien Recibe</td>
                        <td>Entregar</td>
                        <td>Fecha de Entrega</td>
                        <!-- <td>Link Registro</td> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let alumno of alumnos; index as indice">
                        <td>{{alumno.id}}</td>
                        <td>{{alumno.nombre}}</td>
                        <td><div [innerHTML]="alumno.paquetes"></div></td>
                        <td>{{alumno.comprado | currency }}</td>
                        <td>{{alumno.descuento | currency }}</td>
                        <td>{{alumno.total_con_descuento | currency }}</td>
                        <td>{{alumno.pagado | currency}}</td>
                        <td>{{alumno.total_con_descuento - alumno.pagado | currency}}</td>
                        <td><button class="btn btn-info" (click)="getPagos(alumno.id)">Pagos</button></td>
                        <td>
                            <div *ngIf="alumno.estatus == '1' || alumno.estatus == '2'">
                                <textarea [(ngModel)]="observaciones[indice]" placeholder="Observaciones"></textarea>
                            </div>
                            <div *ngIf="alumno.estatus == '3'">
                                {{alumno.observaciones}}
                            </div>
                        </td>
                        <td>
                            <div *ngIf="alumno.estatus == '1' || alumno.estatus == '2'">
                                <textarea [(ngModel)]="recibe[indice]" placeholder="Quién Recibe"></textarea>
                            </div>
                            <div *ngIf="alumno.estatus == '3'">
                                {{alumno.recibio}}
                            </div>
                        </td>
                        <td>
                            <div *ngIf="alumno.estatus == '1' || alumno.estatus == '2'">
                                <div *ngIf="alumno.total_con_descuento - alumno.pagado == 0">
                                    <button class="btn btn-success" (click)="entregarPaquete(alumno.id, indice)">Entregar</button>
                                </div>

                                <div *ngIf="alumno.total_con_descuento - alumno.pagado > 0">
                                    <button class="btn btn-success" disabled>Entregar</button>
                                </div>
                                
                            </div>
                            <div *ngIf="alumno.estatus == '3'">
                                Entregado
                            </div>
                        </td>
                        <td>
                            <div *ngIf="alumno.estatus == '1' || alumno.estatus == '2'">
                               -
                            </div>
                            <div *ngIf="alumno.estatus == '3'">
                                {{alumno.entrego}} <br>
                                {{alumno.fecha_entrega}}
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <td colspan="6"></td>
                    <td>{{pagado | currency}}</td>
                    <td>{{por_cobrar | currency}}</td>
                </tfoot>
            </table>
        </div>
    </div>
</div>


<div id="click" (click)="openModal(myModal)"></div>
<ng-template #myModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Historial de Pagos</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <p>
            <span *ngIf="datos_grupo.forma_pago == 1">Plan 1 50/50 <br></span>
            <span *ngIf="datos_grupo.forma_pago == 2">Plan 2 30/30/40 <br></span>
            <span *ngIf="datos_grupo.fecha_pago_uno">Fecha de pago 1: {{datos_grupo.fecha_pago_uno}}<br></span>
            <span *ngIf="datos_grupo.fecha_pago_dos">Fecha de pago 2: {{datos_grupo.fecha_pago_dos}}<br></span>
            <span *ngIf="datos_grupo.fecha_pago_tres">Fecha de pago 3: {{datos_grupo.fecha_pago_tres}}<br></span>
            
        </p>
        <table class="table table-striped center">
            <thead>
                <tr>
                    <td>ID Pago</td>
                    <td>Folio</td>
                    <td>Fecha</td>
                    <td>Monto</td>
                    <td>Forma de Pago</td>
                    <td>Tipo Pago</td>
                    <td>Registró</td>
                    <td>Recibo</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let pago of pagos">
                    <td>{{pago.id}}</td>
                    <td>{{pago.folio}}</td>
                    <td>{{pago.fecha}}</td>
                    <td>${{pago.monto}}</td>
                    <td>{{pago.forma_pago}}</td>
                    <td>{{pago.tipo_pago}}</td>
                    <td>{{pago.registro}}</td>
                    <td><a href="{{environment}}/api/reciboPago?pago={{pago.id}}" target="_blank">Ver Pago</a></td>
                </tr>
                <tr>
                    <td class="bold">Total</td>
                    <td class="bold">${{total}}</td>
                </tr>
            </tbody>
        </table>
        <p class="center">Saldo <strong>${{saldo}}</strong> de <strong>${{totalCliente}}</strong></p>
    </div>

    <div class="modal-footer">
        <div class="row">
            <div class="col-lg-3">
                <div class="input-group">
                    <input id="fecha_pago_1" class="form-control"  [(ngModel)]="formulario.fecha" placeholder="Fecha de pago yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                    <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                        <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </button>
                    </div>
                </div>
                <br>
            </div>

            <div class="col-lg-3">
                <input type="text" placeholder="Folio" class="form-control" [(ngModel)]="formulario.folio">
            </div>

            <div class="col-lg-3">
                <input type="text" placeholder="Monto" class="form-control" [(ngModel)]="formulario.monto">
            </div>

            <div class="col-lg-3">
                <select #metodoPago class="form-control">
                    <option value="Efectivo">Efectivo</option>
                    <option value="Depósito Bancario">Depósito Bancario</option>
                    <option value="Transferencia Electrónica">Transferencia Electrónica</option>
                    <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
                    <option value="Tarjeta de Débito">Tarjeta de Débito</option>
                </select>
            </div>

            <div class="col-lg-3">
                <select #metodoPago class="form-control" [(ngModel)]="formularioPago.tipo_pago">
                    <option value="">Seleccione tipo de pago</option>
                    <option value="Cuadros">Cuadros</option>
                    <option value="Viaje">Viaje</option>
                    <option value="Fiesta">Fiesta</option>
                </select>
        
            </div>
        </div>
        <button class="btn btn-primary" (click)="agregarPago(usuarioid, metodoPago.value)">Agregar Pago</button>
    </div>
</ng-template>